import { api } from '~/application/api';
import type { ChangeLocationRestrictionCommand, WarehouseLocationDetails } from '../types';

const locationApi = api.enhanceEndpoints({
    addTagTypes: ['WarehouseLocation'],
}).injectEndpoints({
    endpoints: build => ({
        changeLocationRestriction: build.mutation<void, ChangeLocationRestrictionCommand>({
            query: command => ({
                url: `/wms/locations/${command.locationId}/restrictions`,
                method: 'PUT',
                body: command,
            }),
            invalidatesTags: (_, __, arg) =>
                [{ type: 'WarehouseLocation', id: arg.locationId }],
        }),
        removeLocationRestriction: build.mutation<void, string>({
            query: locationId => ({
                url: `/wms/locations/${locationId}/restrictions`,
                method: 'DELETE',
            }),
            invalidatesTags: (_, __, locationId) =>
                [{ type: 'WarehouseLocation', id: locationId }],
        }),
        warehouseLocationDetails: build.query<WarehouseLocationDetails, string>({
            query: locationId => `/wms/locations/${locationId}`,
            providesTags: result => result
                ? [{ type: 'WarehouseLocation', id: result.id }]
                : [],
        }),
    }),
});

export const {
    useChangeLocationRestrictionMutation,
    useRemoveLocationRestrictionMutation,
    useWarehouseLocationDetailsQuery,
} = locationApi;
